module.exports = __webpack_public_path__ + "img/32.8a808c09.png";